
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.502 0c-4.429 0-8.049 3.62-8.049 8.049 0 4.428 3.62 8.049 8.05 8.049 4.428 0 8.048-3.62 8.048-8.05C23.55 3.62 19.93 0 15.502 0zM29.315 22.53a7.502 7.502 0 00-.808-1.477c-1.617-2.39-4.112-3.971-6.924-4.358-.352-.035-.738.035-1.02.246a8.467 8.467 0 01-5.06 1.652 8.467 8.467 0 01-5.062-1.652 1.319 1.319 0 00-1.02-.246 9.932 9.932 0 00-6.923 4.358 8.648 8.648 0 00-.809 1.476c-.105.211-.07.457.035.668.282.492.633.985.95 1.406.491.668 1.019 1.265 1.616 1.828.492.492 1.055.949 1.617 1.406A15.923 15.923 0 0015.467 31c3.445 0 6.784-1.09 9.56-3.163a15.436 15.436 0 001.617-1.406c.562-.563 1.125-1.16 1.617-1.828.351-.457.668-.914.949-1.406.175-.21.21-.457.105-.668z"}})])
          )
        }
      }
    